import {RegexTesterDialog} from '@github-ui/regex-tester-dialog'
import {RegexPatternInput} from '@github-ui/regex-tester-dialog/RegexPatternInput'
import {Button, Checkbox, FormControl} from '@primer/react'
import type {ComponentProps} from 'react'
import {useRef, useState} from 'react'

import styles from './DefinitionRegexEditor.module.css'

interface Props {
  isEnabled: boolean
  pattern: string
  validationError?: string
  onEnabledChange: (enabled: boolean) => void
  onPatternChange: (pattern: string) => void
  inputRef?: ComponentProps<typeof RegexPatternInput>['ref']
}

export function DefinitionRegexEditor({
  isEnabled,
  pattern,
  validationError,
  onEnabledChange,
  onPatternChange,
  inputRef,
}: Props) {
  const [showRegexTestValueDialog, setShowRegexTestValueDialog] = useState(false)
  const testRegexValuesRef = useRef<HTMLButtonElement>(null)

  return (
    <div>
      <FormControl>
        <FormControl.Label>Match regular expression</FormControl.Label>
        <Checkbox
          checked={isEnabled}
          onChange={() => onEnabledChange(!isEnabled)}
          aria-label="Use regular expression"
        />
      </FormControl>
      {isEnabled && (
        <>
          <div className={styles.regexInputContainer}>
            <RegexPatternInput
              ref={inputRef}
              onChange={value => onPatternChange(value)}
              value={pattern}
              validationError={validationError}
            />
          </div>

          <Button
            ref={testRegexValuesRef}
            onClick={() => setShowRegexTestValueDialog(true)}
            className={styles.testRegexButton}
          >
            Test values…
          </Button>
          {showRegexTestValueDialog && (
            <RegexTesterDialog
              onDismiss={() => setShowRegexTestValueDialog(false)}
              onRegexPatternChange={value => onPatternChange(value)}
              regexPattern={pattern}
              regexPatternValidationError={validationError}
              returnFocusRef={testRegexValuesRef}
            />
          )}
        </>
      )}
    </div>
  )
}

try{ DefinitionRegexEditor.displayName ||= 'DefinitionRegexEditor' } catch {}